import React, { useState, useEffect, useRef } from "react";
import Papa from "papaparse";
import {
  Button,
  DateRangePicker,
  DownloadButton,
  LoadingComponent,
} from "../../../components/core";

import { ContentContainer } from "../../../components/layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { Card } from "primereact/card";

const LockerFullReport = () => {
  const maxDate = (() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d;
  })();

  const [convertedData, setconvertedData] = useState([]);
  //   const [startDate, setStartDate] = useState(maxDate);
  //   const [endDate, setEndDate] = useState(new Date());
  const [searchResultHeader, setSearchResultHeader] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const dt = useRef(null);
  const [filterVariables, setFilterVariables] = useState({
    startDate: maxDate,
    endDate: new Date(),
  });

  function handleSearchResultHeader() {
    setSearchResultHeader(`
      from ${formatDate(filterVariables.startDate)} to ${formatDate(
      filterVariables.endDate
    )}
      `);
  }

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
    const day = String(d.getDate()).padStart(2, "0"); // Ensure two-digit day
    return `${year}-${month}-${day}`;
  };

  const fetchAll = async () => {
    const start = formatDate(filterVariables.startDate);
    const end = formatDate(filterVariables.endDate);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_LOCKER_FULL_CSV}?${Date.now()}`
      );
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: false,
        dynamicTyping: true,
        complete: (result) => {
          var tempData = [];
          const uniqueNames = new Set();
          result.data.forEach((k, i) => {
            let obj = { ...k };
            if (obj[0] >= start && obj[0] <= end) {
              if (obj[0]) {
                obj.id = obj[3] + obj[4];
                if (i == 0) {
                  tempData.push(obj);
                  uniqueNames.add(obj[3] + obj[4]);
                  if (obj[2] == 0) {
                    obj.zero = 1;
                  } else {
                    obj.nonzero = 1;
                  }
                  obj.blank = "";
                  obj.total = 1;
                } else {
                  if (!uniqueNames.has(obj[3] + obj[4])) {
                    uniqueNames.add(obj[3] + obj[4]);
                    if (obj[2] == 0) {
                      obj.zero = 1;
                    } else {
                      obj.nonzero = 1;
                    }
                    obj.total = 1;
                    tempData.push(obj);
                  } else {
                    const tempObj = tempData.find(
                      (item) => item.id === obj[3] + obj[4]
                    );
                    if (obj[2] == 0) {
                      tempObj.zero = (tempObj.zero ?? 0) + 1;
                    } else {
                      tempObj.nonzero = (tempObj.nonzero ?? 0) + 1;
                    }
                    tempObj.total = tempObj.total + 1;
                  }
                }
              }
            }
          });
          setconvertedData(tempData);
        },
      });
    } catch (error) {
      console.error("Error fetching or parsing CSV:", error);
    }
  };

  const handleSearch = async () => {
    setisLoading(true);
    fetchAll().then((r) => {
      setisLoading(false);
    });
    handleSearchResultHeader();
  };

  const handleFilterChange = (e, field) => {
    let value = e.target.value;
    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }

    // If changing partner company, also clear partner branch
    if (field === "selectedPartnerCompany") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedPartnerBranch: [], // Clear partner branch when company changes
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          field="id"
          header="Locker Name"
          rowSpan={2}
          sortable
          headerStyle={{
            textAlign: "center",
            backgroundColor: "#facc15",
            color: "black",
            borderRight: "2px solid rgb(168 162 158)",
          }}
        />
        <Column
          header="Doors Left"
          colSpan={2}
          headerStyle={{
            paddingLeft: "12%",
            fontSize: "1.1em",
            backgroundColor: "#facc15",
            color: "black",
            borderRight: "2px solid rgb(168 162 158)",
          }}
        />
        <Column
          field="total"
          header="Total"
          rowSpan={2}
          sortable
          headerStyle={{ backgroundColor: "#facc15", color: "black" }}
        />
      </Row>
      <Row>
        <Column
          field="nonzero"
          header="1 or 2"
          sortable
          headerStyle={{
            backgroundColor: "#facc15",
            color: "black",
            borderRight: "2px solid rgb(168 162 158)",
            borderTop: "2px solid rgb(168 162 158)",
          }}
        />
        <Column
          field="zero"
          header="0"
          sortable
          headerStyle={{ backgroundColor: "#facc15", color: "black" }}
        />
      </Row>
    </ColumnGroup>
  );
  return (
    <ContentContainer containerTitle={"Locker Full Alerts Report"}>
      <div>
        <h1 className={"font-bold pb-2"}>Date range:</h1>
        {/* <DateRangePicker
					className={"w-1/2"}
					startDate={startDate}
					endDate={endDate}
					onChange={(event) => {
						if (event.target.name === "signupDateFrom") {
							setStartDate(event.target.value);
						} else {
							setEndDate(event.target.value);
						}
					}}
				/> */}

        <PrimereactDateRange
          className={"w-1/2"}
          startDate={filterVariables.startDate}
          endDate={filterVariables.endDate}
          startDateName="startDate"
          endDateName="endDate"
          readOnlyInput={true}
          max={new Date()} // Today's date as the maximum
          min={new Date("2021-01-01")} // Jan 1, 2021, as the minimum
          onChange={(event, fieldName) => {
            handleFilterChange(event, fieldName);
          }}
        />
        <div className="grid grid-cols-2 w-1/2 gap-y-2">
          <div></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              setFilterVariables({
                ...filterVariables,
                startDate: maxDate,
                endDate: new Date(),
              });
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>

        <Button
          value={"Search"}
          onClick={handleSearch}
          className={"w-40 h-8 m-4 cursor-pointer"}
        />
        {isLoading && <LoadingComponent />}
        {convertedData.length > 0 && !isLoading && (
          <Card>
            <>
              <div className="flex flex-row gap-1">
                <p>Total: </p>
                <p className="font-bold">{convertedData.length}</p>
              </div>
              <DownloadButton dt={dt} id={"Locker Full Report"} />
              <div
                className="bg-primary-primaryYellow border-b-2 border-stone-400"
                id="Locker Full Report"
              >
                <p className="text-xl text-center font-bold pb-2 bg-primary ">{` Search result for Locker Full Alerts  ${searchResultHeader}`}</p>
                <DataTable
                  value={convertedData}
                  multiSortMeta={[
                    { field: "zero", order: -1 },
                    { field: "total", order: -1 },
                  ]}
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  className="border-2 border-stone-400"
                  headerColumnGroup={headerGroup}
                  exportFilename="Locker Full Alert Report"
                  ref={dt}
                >
                  <Column
                    field="id"
                    bodyStyle={{ borderTop: "0.5px solid grey" }}
                    exportHeader="Locker Name"
                  ></Column>
                  <Column
                    field="nonzero"
                    bodyStyle={{ borderTop: "0.5px solid grey" }}
                    exportHeader="1 or 2 Door Available Left Alerts"
                  ></Column>
                  <Column
                    field="zero"
                    sortable
                    bodyStyle={{ borderTop: "0.5px solid grey" }}
                    exportHeader="No Door Available Left Alerts"
                  ></Column>
                  <Column
                    field="total"
                    sortable
                    bodyStyle={{ borderTop: "0.5px solid grey" }}
                    exportHeader="Total Alerts"
                  ></Column>
                  <Column
                    field={"blank"}
                    header={searchResultHeader}
                    style={{ display: "none" }}
                  ></Column>
                </DataTable>
              </div>
            </>
          </Card>
        )}
      </div>
    </ContentContainer>
  );
};

export default LockerFullReport;

function formatDate(inputDate) {
  if (inputDate == null) {
    return "";
  }
  const date = new Date(inputDate);
  const options = { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
}

const addDate = (id, year, data) => {
  const obj = data.find((item) => item.id === id);

  if (obj && obj.dates) {
    if (!obj.dates.includes(year)) {
      obj.dates.push(year);
      obj.total = obj.total + 1;
    }
  } else {
    console.error(
      `Object with id ${id} not found or does not have a 'dates' array`
    );
  }
};
